import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { Paperclip, X, FileText } from "@phosphor-icons/react";

export const MISSING_DOC_OPTIONS = ["STNK", "SIM", "Buku KIR", "BPKB", "KTP", "Laporan Polisi", "Foto Kerusakan", "Kunci Kendaraan"];

export const MissingDocsBox = ({ visible, missingDocs, setMissingDocs, otherDoc, setOtherDoc }) => {
  if (!visible) return null;
  return (
    <div data-testid="missing-docs-section" className="border border-amber-300 bg-amber-50/60 p-4 space-y-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-amber-800 flex items-center gap-1.5">
        <FileText size={14} /> Dokumen yang belum dilengkapi
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2.5">
        {MISSING_DOC_OPTIONS.map((d) => (
          <label key={d} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox data-testid={`missing-doc-${d.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              checked={missingDocs.includes(d)}
              onCheckedChange={(v) => setMissingDocs((s) => (v ? [...s, d] : s.filter((x) => x !== d)))} />
            {d}
          </label>
        ))}
      </div>
      <Input data-testid="input-missing-doc-other" value={otherDoc} onChange={(e) => setOtherDoc(e.target.value)}
        placeholder="Dokumen lain (opsional) — mis. Faktur Pembelian" className="bg-white" />
    </div>
  );
};

export const FilesBox = ({ files, setFiles }) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <Label className="text-xs uppercase tracking-wide text-muted-foreground">Dokumen Pendukung (opsional)</Label>
      <input id="claim-files-input" type="file" multiple className="hidden" data-testid="claim-files-input"
        accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx,.txt,.csv,.mp4"
        onChange={(e) => {
          const list = [...e.target.files].filter((f) => f.size <= 10 * 1024 * 1024);
          if (list.length < e.target.files.length) toast.error("File lebih dari 10 MB dilewati");
          setFiles((s) => [...s, ...list]);
          e.target.value = "";
        }} />
      <Button type="button" variant="outline" size="sm" data-testid="attach-files-button"
        onClick={() => document.getElementById("claim-files-input").click()} className="rounded-none h-8 gap-2">
        <Paperclip size={14} /> Lampirkan File
      </Button>
    </div>
    {files.length > 0 && (
      <div className="border border-border/60 divide-y divide-border/60">
        {files.map((f, i) => (
          <div key={`${f.name}-${f.size}-${f.lastModified}`} className="flex items-center justify-between px-3 py-1.5 text-sm">
            <span className="truncate">{f.name} <span className="text-xs text-muted-foreground">({Math.max(1, Math.round(f.size / 1024))} KB)</span></span>
            <button type="button" data-testid={`remove-file-${i}`} onClick={() => setFiles((s) => s.filter((_, j) => j !== i))}
              className="text-muted-foreground hover:text-red-600 transition-colors duration-150"><X size={14} /></button>
          </div>
        ))}
      </div>
    )}
    <p className="text-xs text-muted-foreground mt-1.5">Foto kejadian, KTP, salinan polis, laporan polisi, dll. Maks 10 MB per file — diunggah otomatis setelah klaim tersimpan.</p>
  </div>
);
